import React, { useState } from "react";
import { Link } from "gatsby";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import imgArrow from "../../../assets/image/before-after/arrow.svg";
import imgC from "../../../assets/image/customers/Amelie White.png";
import imgStars from "../../../assets/image/svg/five-stars-rating.svg";
// general manager
// owner
// co-owner
// manager

const BEFORE_ITEMS = [
  {
    img: imgC,
    brandName: "Truworth Care",
    position: "Business Owner",
    fname: "Nokuthula",
    lname: "Sibanda",
    whattheysaid:
      "Hiring someone to handle every aspect is extremely expensive and it’s hard to find a tool which can help you to do most of the business needs.",
    link: "https://camelohq.com/customers/truworth-care-story/",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/22235720/Nokuthula-Sibanda.png",
  },
  {
    img: imgC,
    brandName: "BDash Logistics",
    position: "Business Owner",
    fname: "Barry",
    lname: "Dunn",
    whattheysaid:
      "Our original solutions of recording everything in Excel spreadsheets and shared notepads weren't as efficient as we needed. Making constant changes to my Excel spreadsheets was very tedious and time-consuming.",
    link: "https://camelohq.com/customers/bdash-logistics-scheduling-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/22235843/Barry-Dunn.png",
  },
  {
    img: imgC,
    brandName: "Whittlesey Christian Church",
    position: "The Church Leader",
    fname: " Richard",
    lname: "Bibby",
    whattheysaid:
      "It's a challenge keeping track with physical rotas and remembering to tell people. Inevitably, if plans are changed, misunderstandings happen.",
    link: "https://camelohq.com/customers/whittlesey_church_story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000138/Richard-Bibby.png",
  },
  {
    img: imgC,
    brandName: "Kohvieri",
    position: "",
    fname: "Kohvieri's",
    lname: "Manager",
    whattheysaid:
      "We used to have problems with making schedules because then we had to gather all the workers to make a schedule that works for everybody with paper and pen.",
    link: "https://camelohq.com/customers/kohvieri_coffee_shop_story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000317/Kohvieri.png",
  },
  {
    img: imgC,
    brandName: "The UPS Store Creekside",
    position: "Assistant Manager",
    fname: "Joshua",
    lname: "Bargmann",
    whattheysaid:
      "It was also difficult to keep up with shift swaps on a physical schedule and we were having to take photos so people could see their schedules day to day.",
    link: "https://camelohq.com/customers/ups-store-creekside",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000501/Joshua-Bargmann.png",
  },
  {
    img: imgC,
    brandName: "La Mex Restaurant",
    position: "Manager",
    fname: "Talia",
    lname: "Valdez",
    whattheysaid:
      "And ever since I started hiring more employees and growing a bigger crew, people would ask for days off, and I’d just say yes in the moment, and totally forget that they’d asked for that certain day off. It was so embarrassing.",
    link: "https://camelohq.com/customers/la-mex-restaurant-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000633/Talia-Valdez.png",
  },
  {
    img: imgC,
    brandName: "Next Wave Neurodiagnostics",
    position: "Business Owner",
    fname: "Osvaldo",
    lname: "Johnson",
    whattheysaid:
      "I have tried different methods to keep things nice and easy but human error would always come into play and mistakes kept happening.",
    link:
      "https://camelohq.com/customers/next-wave-neurodiagnostics-customer-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000731/Osvaldo-Johnson.png",
  },
  {
    img: imgC,
    brandName: "The Big Event",
    position: "Business Owner",
    fname: "John",
    lname: "King",
    whattheysaid: "Communicating with employees was difficult.",
    link:
      "https://camelohq.com/customers/the-big-event-photography-customer-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001019/John-King.png",
  },
  {
    img: imgC,
    brandName: "JCare Support Services",
    position: "Co-founder",
    fname: "Brooke",
    lname: "Sanderson",
    whattheysaid:
      "Tracking staff hours was becoming incredibly time-consuming as there were ALWAYS mistakes.",
    link: "https://camelohq.com/customers/jcare-support-sevices-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001124/Brooke-Sanderson.png",
  },
  {
    img: imgC,
    brandName: "Masfjordnes Hotel",
    position: "Manager",
    fname: "Jesper",
    lname: "Borlaug Nesse",
    whattheysaid:
      "Previously, we had the work schedule on a common screen, so everyone spent a lot of time going to this to see what they were supposed to do.",
  },
  {
    img: imgC,
    brandName: "KUMA Fit",
    position: "Business Owner",
    fname: "Stacy",
    lname: "Kim",
    whattheysaid:
      "Although we have a physical space, we manage our team remotely since we aren't all in the same space at the same time. Making sure announcements get to people on time is really important for us.",
    link: "https://camelohq.com/customers/kuma-fit-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001327/Stacy-Kim.png",
  },
  {
    img: imgC,
    brandName: "Senyorial",
    position: "Business Owner",
    fname: "Adrià",
    lname: "Folie",
    whattheysaid:
      "Scheduling process was slow and took time. Communicating with employees was difficult.",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001614/Adria-Folie.png",
  },
  {
    img: imgC,
    brandName: "",
    position: "Team Manager",
    fname: "Rose",
    lname: "Nguyen",
    whattheysaid:
      "We used to schedule on paper and it's hard to arrange shifts and let my team know if there's changes. Calculating work hours is manual too so sometimes there are miscalculations. And we used to communicate using WhatsApp but people miss messages a lot.",
    link: "https://www.g2.com/products/camelo/reviews/camelo-review-10887652",
  },
  {
    img: imgC,
    brandName: "",
    position: "Hospital Administrator",
    fname: "Harry",
    lname: "Wilson",
    whattheysaid:
      "Before Camelo, scheduling was a mess. It took forever, and keeping track of shift changes was a hassle.",
    link: "https://www.g2.com/products/camelo/reviews/camelo-review-10892099",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001916/Harry-Wilson.png",
  },
  {
    img: imgC,
    brandName: "",
    position: "Manager",
    fname: "Abigail",
    lname: "Barrera",
    whattheysaid:
      "We used Google Calendar to schedule shifts and Slack for communicating with our staff, so it's quite cumbersome to switch between the two apps.",
    link: "https://www.g2.com/products/camelo/reviews/camelo-review-10952608",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23002059/Abigail-Barrera.png",
  },
  {
    img: imgC,
    brandName: "Pristine Pros Cleaning",
    position: "Business Owner",
    fname: "Laurence",
    lname: "Schneider",
    whattheysaid:
      "I felt like half of the time managing my business I spent on scheduling shifts.",
  },
  {
    img: imgC,
    brandName: "Diamond Ridge Construction	",
    position: "Co-owner",
    fname: "Thomas",
    lname: "Bailey",
    whattheysaid:
      "So many emails back and forth for sick-leave and time-off requests. So difficult to manage who's on and who's off. So much hassle for keeping track of things.",
  },
  {
    img: imgC,
    brandName: "El Pirata Porch Restaurant",
    position: "General Manager",
    fname: "Alex",
    lname: "Kolly",
    whattheysaid:
      "I hesitated to use a digital method to manage my team because I wasn't a high-tech person. I was wrong. I could use paper and pen for drawing, writing, not scheduling.",
  },
  {
    img: imgC,
    brandName: "Atomic Liquors",
    position: "Business Owner",
    fname: "Solbritt",
    lname: "Olofsson",
    whattheysaid:
      "I used a whiteboard and paper before Camelo. I quickly realized that using those made me miserable. I spent hours crafting schedules for my staff. I could use those hours for something better.",
  },
  {
    img: imgC,
    brandName: "Fonseca Burger",
    position: "Business Owner",
    fname: "Nadia",
    lname: "Alfaro",
    whattheysaid:
      "Our team had a difficult time keeping track of shifts, available members, and tasks. We used several apps to manage these things, but none of them made our lives easier.",
  },
  {
    img: imgC,
    brandName: "Grove Link Clinic",
    position: "Co-owner",
    fname: "Dr. Gunnar",
    lname: "Erdman",
    whattheysaid:
      "Checking attendance used to be tedious and tiring for me. Keeping track of the hours and data took me hours whether I use pen and paper or a spreadsheet.",
  },
  {
    img: imgC,
    brandName: "Sesto Italiano Restaurant",
    position: "Co-owner",
    fname: "Donatella",
    lname: "Bellini",
    whattheysaid:
      "I had to hunt for available employees, literally, whenever there were time-off requests. I tried to call and text my staff like crazy to find a good match for the shifts.",
  },
  {
    img: imgC,
    brandName: "Samurai Clearning",
    position: "Business Owner",
    fname: "Charlotte",
    lname: "Lewis",
    whattheysaid:
      "I spent a considerable amount of money on paper time cards and paper schedules. Every time there were changes, I had to print new ones or find a way to notify my staff. Exhausting and time-consuming.",
  },
  {
    img: imgC,
    brandName: "Onyx General Contractors",
    position: "Business Owner",
    fname: "Andy",
    lname: "King",
    whattheysaid:
      "My employee schedule was always chaotic. I had to dig through piles of papers and made endless calls almost every day to find the right people for vacant shifts.",
  },
  {
    img: imgC,
    brandName: "Ace & Hammer Builders	",
    position: "Manager",
    fname: "Jade",
    lname: "Roberts",
    whattheysaid:
      "Time-off and leave requests came up all the time. I had to find the right substitutes, contact them, and ask if they could step in. If I were lucky, they'd agree. Most of the time, they didn't. That cycle went on until someone finally accepted. That frustrated the hell out of me.",
  },
  {
    img: imgC,
    brandName: "Dust & Shine Co.",
    position: "Business Owner",
    fname: "Will",
    lname: "Morris",
    whattheysaid:
      "I used to distribute paper schedules to my staff every week. If a staff decided to take a day off, I had to notify all of the others. It was time-consuming and annoying.",
  },
  {
    img: imgC,
    brandName: "Royal Maid Cleaning Service",
    position: "Business Owner",
    fname: "Melissa",
    lname: "Collins",
    whattheysaid:
      "I had to be very careful not to overschedule my staff. Paper time cards, counting total work hours and stuff. I did them manually. Urgh.",
  },
  {
    img: imgC,
    brandName: "Cordial Care",
    position: "Business Owner",
    fname: "Rocio",
    lname: "Nitzsche",
    whattheysaid:
      "We had 20 members in our team. Every time the schedule was adjusted, I had to update the changes via email and phone to 20 people, and made sure they'd received the updates. When they didn't reply, I had to call them. That was certainly not a great way to manage our schedule.",
  },
  {
    img: imgC,
    brandName: "Nurture And Nurse",
    position: "Co-owner",
    fname: "Dr. Dasia",
    lname: "Crist",
    whattheysaid:
      "It was difficult to assign tasks to my staff and keep track of who's doing what. I'd never really had time to organize them. Sometimes I wrote the tasks and names down on paper, other times I kept them on my phone. I had to literally dig through every document and note, digitally and physically, whenever I needed certain information.",
  },
  {
    img: imgC,
    brandName: "Healing Equilibrium Clinic",
    position: "Co-owner",
    fname: "Keanu",
    lname: "Grady",
    whattheysaid:
      "I struggled with time-off requests and attendance a lot. I once forgot to find a replacement for a vacant shift. The workflow was messed up, the customers were dissatisfied, the available employees were exhausted, and I felt terrible.",
  },
];

const AFTER_ITEMS = [
  {
    img: imgC,
    brandName: "Truworth Care",
    position: "Business Owner",
    fname: "Nokuthula",
    lname: "Sibanda",
    whattheysaid:
      "Camelo is a tool that is closer to providing all my business needs in one app. The scheduling, time tracking, and communication through boards with staff were easy.",
    link: "https://camelohq.com/customers/truworth-care-story/",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/22235720/Nokuthula-Sibanda.png",
  },
  {
    img: imgC,
    brandName: "BDash Logistics",
    position: "Business Owner",
    fname: "Barry",
    lname: "Dunn",
    whattheysaid:
      "With Camelo, I'm able to post the schedules in a few steps. It has been extremely useful for the drivers to be able to submit any time-off requests within the app, without management having to try to remember who needed off and when.",
    link: "https://camelohq.com/customers/bdash-logistics-scheduling-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/22235843/Barry-Dunn.png",
  },
  {
    img: imgC,
    brandName: "Whittlesey Christian Church",
    position: "The Church Leader",
    fname: "Richard",
    lname: "Bibby",
    whattheysaid:
      "The app gives us the peace of mind that something is in place and meets our needs. I am slowly learning to work with people better with the help from Camelo.",
    link: "https://camelohq.com/customers/whittlesey_church_story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000138/Richard-Bibby.png",
  },
  {
    img: imgC,
    brandName: "Kohvieri",
    position: "",
    fname: "Kohvieri's",
    lname: "Manager",
    whattheysaid:
      "I absolutely love the support team in Camelo. If I have a question they help immediately, and if I have a problem with anything then they are supportive and trying to find a solution for both sides.",
    link: "https://camelohq.com/customers/kohvieri_coffee_shop_story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000317/Kohvieri.png",
  },
  {
    img: imgC,
    brandName: "UPS Store Creekside",
    position: "Assistant Manager",
    fname: "Joshua",
    lname: "Bargmann",
    whattheysaid: "After testing over 40 apps, Camelo was by far the best.",
    link: "https://camelohq.com/customers/ups-store-creekside",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000501/Joshua-Bargmann.png",
  },
  {
    img: imgC,
    brandName: "La Mex Restaurant",
    position: "Manager",
    fname: "Talia",
    lname: "Valdez",
    whattheysaid:
      "It helped with my anxiety more than anything. No more embarrassing moments when I’ve forgotten someone’s day off. So, more peaceful nights and, especially, more time with my lovely family!",
    link: "https://camelohq.com/customers/la-mex-restaurant-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000633/Talia-Valdez.png",
  },
  {
    img: imgC,
    brandName: "Brick",
    position: "Head of Department",
    fname: "Donnie",
    lname: "Silalahi",
    whattheysaid:
      "Camelo saved about 5 hours a week that I can now spend on strategies that improve our services and operations.",
    link: "https://camelohq.com/customers/brick-finance-customer-story/",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000839/Donnie-Silalahi.png",
  },
  {
    img: imgC,
    brandName: "Next Wave Neurodiagnostics",
    position: "Business Owner",
    fname: "Osvaldo",
    lname: "Johnson",
    whattheysaid:
      "After a while, Camelo became pretty straightforward and intuitive to use.",
    link:
      "https://camelohq.com/customers/next-wave-neurodiagnostics-customer-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23000731/Osvaldo-Johnson.png",
  },
  {
    img: imgC,
    brandName: "The Big Event",
    position: "Business Owner",
    fname: "John",
    lname: "King",
    whattheysaid:
      "Camelo saves me countless hours during the year so I can focus on work instead of scheduling.",
    link:
      "https://camelohq.com/customers/the-big-event-photography-customer-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001019/John-King.png",
  },
  {
    img: imgC,
    brandName: "JCare Support Services",
    position: "Co-founder",
    fname: "Brooke",
    lname: "Sanderson",
    whattheysaid:
      "I have been incredibly happy with everything—from customer service to the app and website usage.",
    link: "https://camelohq.com/customers/jcare-support-sevices-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001124/Brooke-Sanderson.png",
  },
  {
    img: imgC,
    brandName: "Masfjordnes Hotel",
    position: "Manager",
    fname: "Jesper",
    lname: "Borlaug Nesse",
    whattheysaid:
      "Camelo has made everything from shift scheduling to payroll more efficient for us, and this means that managers have more time to help around the various departments.",
  },
  {
    img: imgC,
    brandName: "KUMA Fit",
    position: "Business Owner",
    fname: "Stacy",
    lname: "Kim",
    whattheysaid:
      "We love the message board feature because it allows our team to announce important messages and see who has not acknowledged them. Making sure announcements get to people on time is really important for us.",
    link: "https://camelohq.com/customers/kuma-fit-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001327/Stacy-Kim.png",
  },
  {
    img: imgC,
    brandName: "KUMA Fit",
    position: "Business Owner",
    fname: "Stacy",
    lname: "Kim",
    whattheysaid:
      "One thing I LOVE that we didn't have before is the ability to schedule recurring shifts. This means we don't need to copy from the previous week or make templates, we can just set each shift as a recurring one and publish one month at a time.",
    link: "https://camelohq.com/customers/kuma-fit-story",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001327/Stacy-Kim.png",
  },
  {
    img: imgC,
    brandName: "Senyorial",
    position: "Business Owner",
    fname: "Adrià",
    lname: "Folie",
    whattheysaid:
      "Camelo's task management and gelocation clock in and clock out have helped me schedule employees better.",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001614/Adria-Folie.png",
  },
  {
    img: imgC,
    brandName: "Senyorial",
    position: "Business Owner",
    fname: "Adrià",
    lname: "Folie",
    whattheysaid:
      "Sure I do recommend Camelo because it's all in one to manage employees, scheduling and exporting data.",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001614/Adria-Folie.png",
  },
  {
    img: imgC,
    brandName: "",
    position: "Team Manager",
    fname: "Rose",
    lname: "Nguyen",
    whattheysaid:
      "There's various options to punch in and out and the recorded worked hours are accurate. A huge plus is the app is aesthetically pleasing, which my team really enjoys. Everything is smooth so far.",
    link: "https://www.g2.com/products/camelo/reviews/camelo-review-10887652",
  },
  {
    img: imgC,
    brandName: "",
    position: "Hospital Administrator",
    fname: "Harry",
    lname: "Wilson",
    whattheysaid:
      "Everything’s in one place—scheduling, timesheets, task tracking. It’s easy to use, which is a big deal when you don’t have time to waste clicking around.",
    link: "https://www.g2.com/products/camelo/reviews/camelo-review-10892099",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23001916/Harry-Wilson.png",
  },
  {
    img: imgC,
    brandName: "",
    position: "Manager",
    fname: "Abigail",
    lname: "Barrera",
    whattheysaid:
      "Camelo helps me manage my team's schedule and communication. It is also so easy to check my team member leave requests.",
    link: "https://www.g2.com/products/camelo/reviews/camelo-review-10952608",
    avatar:
      "https://blog-assets.camelohq.com/wp-content/uploads/2025/04/23002059/Abigail-Barrera.png",
  },
  {
    img: imgC,
    brandName: "Lee Harvey’s",
    position: "Co-owner",
    fname: "Seth",
    lname: "Smith",
    whattheysaid:
      "Finally, we don't have to be drowned in endless piles of paper schedules anymore. My team members are notified whenever there are changes in the schedule. No one misses their shifts anymore.",
  },
  {
    img: imgC,
    brandName: "J&D Cafe",
    position: "Business Owner",
    fname: "Jared",
    lname: "Lebsack",
    whattheysaid:
      "All of my staff's shifts, tasks, and time-off requests are in one place—my phone. Managing my staff has become easier with just a few swipes and touches on the screen.",
  },
  {
    img: imgC,
    brandName: "Clippings N Cuts",
    position: "Business Owner",
    fname: "Ravi",
    lname: "DeRossi",
    whattheysaid:
      "I can easily see who's on and who's off, who's available and who's not.",
  },
  {
    img: imgC,
    brandName: "Lavish Health Clinic",
    position: "General Manager",
    fname: "Kate",
    lname: "Johnston",
    whattheysaid:
      "I no longer dread looking for shift replacements. Camelo recommends who's appropriate for the shift, and I simply need to choose a name.",
  },
  {
    img: imgC,
    brandName: "The Snippers",
    position: "Business Owner",
    fname: "Ashley",
    lname: "S.",
    whattheysaid:
      "With the help of Camelo, it's so easy to keep everyone updated on their new schedules.",
  },
  {
    img: imgC,
    brandName: "Healthstone Community Hospital",
    position: "General Manager",
    fname: "Kenny",
    lname: "Price",
    whattheysaid:
      "My staff can now update their availability, claim shifts, and swap shifts quickly. Scheduling is no longer a burden to me.",
  },
  {
    img: imgC,
    brandName: "Smart n Savvy Contractors",
    position: "Co-owner",
    fname: "Stefan",
    lname: "Heller",
    whattheysaid:
      "I tried several tools to manage my staff and keep our business running smoothly, but none of them matched my needs. I came across Camelo one day, decided to give it a try, and I haven't looked for anything else ever since. Everything I need is now in one place.",
  },
  {
    img: imgC,
    brandName: "British Hairways",
    position: "Business Owner",
    fname: "Sameera",
    lname: "Mangal",
    whattheysaid:
      "My employees used to send me time-off and leave requests via email. Communication was slow and inefficient. Different emails floated everywhere. Camelo allows me to approve and deny those requests right on my phone.",
  },
  {
    img: imgC,
    brandName: "Safari Lawn Care",
    position: "Business Owner",
    fname: "Dhiraj",
    lname: "Dalal",
    whattheysaid:
      "No shifts are forgotten, no tasks are unfinished, and I always know what my staff are doing.",
  },
  {
    img: imgC,
    brandName: "Charleston Clinics",
    position: "GM",
    fname: "Seth",
    lname: "Johnston",
    whattheysaid:
      "I like how my staff can open the app and view their shifts right away.",
  },
  {
    img: imgC,
    brandName: "TurfClips Lawn Care",
    position: "Co-owner",
    fname: "Fannie",
    lname: "Kessler",
    whattheysaid:
      "I often have too much on my plate. Camelo takes scheduling and task assigning off my plate.",
  },
  {
    img: imgC,
    brandName: "Premier Home Consulting",
    position: "Business Owner",
    fname: "Kristian",
    lname: "Dach",
    whattheysaid:
      "Shifts and tasks are now so well-organized. No more papers, cross-marks, strike-throughs!",
  },
  {
    img: imgC,
    brandName: "Anita Haircut",
    position: "Business Owner",
    fname: "Aditya",
    lname: "Gerhold",
    whattheysaid:
      "We don't have to jump between spreadsheets, group chats, and emails to know who's working and who's not anymore.",
  },
  {
    img: imgC,
    brandName: "Sharper Shop",
    position: "Business Owner",
    fname: "Callum",
    lname: "Campbell",
    whattheysaid:
      "We've saved lots of time on managing availability and time-off, as well as planning shifts and assigning tasks.",
  },
  {
    img: imgC,
    brandName: "Base Mountain Construction",
    position: "General Manager",
    fname: "Ivah",
    lname: "Hammer",
    whattheysaid:
      "I love that we can contact each other and view our shifts without jumping from one app to another.",
  },
  {
    img: imgC,
    brandName: "Rose Valley Medical Center",
    position: "General Manager",
    fname: "Frau Dr. Saskia",
    lname: "Rapp B.A.",
    whattheysaid:
      "I can now ask my staff to clean the kitchen, restock the ingredients, and update the menu right on my phone. My staff are notified and reminded of their tasks via mobile notifications, and they can always access their task list in case they forget what they need to do.",
  },
  {
    img: imgC,
    brandName: "Sunshine Build Group",
    position: "Co-owner",
    fname: "Gunner",
    lname: "Fritsch",
    whattheysaid:
      "We can now message team members quickly without going through a long and tedious chain of emails.",
  },
  {
    img: imgC,
    brandName: "Charleston Clinics",
    position: "Business Owner",
    fname: "Dr. Makayla",
    lname: "Murphy",
    whattheysaid:
      "Our team communication is enhanced by 75% since using Camelo. Everyone can receive messages instantly and respond promptly.",
  },
  {
    img: imgC,
    brandName: "Green Concrete Builder",
    position: "Business Owner",
    fname: "Wyman",
    lname: "Dare",
    whattheysaid:
      "I no longer face the pressure of crafting the appropriate emails with the right words. From asking my coworkers to cover each other's shifts to sending time-off requests to my manager, Camelo makes them all easier.",
  },
];

const BubbleTalk = ({
  position,
  brandName,
  fname,
  lname,
  whattheysaid,
  showStars,
  link,
  avatar,
}) => {
  return (
    <>
      <Link to={link} target="__blank">
        <Card className="p-lg-3 p-xs-1 mb-8 mb-lg-16 justify-content-center gr-hover-shadow-3">
          <blockquote className="blockquote mb-0 card-body mx-auto text-left">
            {showStars && (
              <div>
                <img
                  src={imgStars}
                  style={{
                    width: "7rem",
                    marginBottom: "1rem",
                  }}
                />
              </div>
            )}
            <div className="d-flex text-left align-items-center">
              {avatar ? (
                <div className="mr-5 d-flex justify-content-center align-items-center">
                  <img
                    className="rounded-circle h-auto overflow-hidden"
                    style={{
                      backgroundColor: "transparent",
                      width: "48px",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "#E5E5E5",
                    }}
                    width="48"
                    src={avatar}
                    alt={brandName}
                  />
                </div>
              ) : (
                <div className="mr-5 d-flex justify-content-center align-items-center">
                  <div
                    className="rounded-circle overflow-hidden"
                    style={{
                      backgroundColor: "#F8F4EE",
                      width: "48px",
                      height: "48px",
                      fontFamily: "inherit",
                      fontSize: "32px",
                      fontWeight: "800",
                      color: "#5856D6",
                      textAlign: "center",
                      lineHeight: "48px",
                    }}
                  >
                    {fname.charAt(0)}
                  </div>
                </div>
              )}
              <div className="gr-text-10 gr-color-blackish-blue-opacity-8">
                <div>
                  <strong>{brandName}</strong>
                </div>
                <div>
                  {fname + " " + lname}
                  {position ? <span> ({position})</span> : null}
                </div>
              </div>
              {/* <img className="zoomable rounded-circle h-auto overflow-hidden" style={{backgroundColor: "#C3AEFF", width: "40px"}} width="40" src={img} alt="" /> */}
            </div>
            <footer>
              <p className="text-black pt-6"> {whattheysaid} </p>
            </footer>
          </blockquote>
        </Card>
      </Link>
    </>
  );
};

const reviewPerPage = 4;
const TOTAL_REVIEWS = 142;

const PeopleAreTalking = () => {
  const [totalReviews, setTotalReviews] = useState(
    TOTAL_REVIEWS - reviewPerPage,
  );
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [beforeItems, setBeforeItems] = useState(
    BEFORE_ITEMS.slice(0, reviewPerPage),
  );
  const [afterItems, setAfterItems] = useState(
    AFTER_ITEMS.slice(0, reviewPerPage),
  );

  const loadMoreReviews = () => {
    if (totalReviews < 122) {
      setShowLoadMore(false);
    }
    let ll = TOTAL_REVIEWS - totalReviews + reviewPerPage;
    setBeforeItems(BEFORE_ITEMS.slice(0, ll));
    setAfterItems(AFTER_ITEMS.slice(0, ll));
    setTotalReviews(totalReviews - reviewPerPage);
  };

  return (
    <>
      <div className="pt-18 bg-default-9" id="elPeopleSaid">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" md="5" className="text-center">
              <h3 className="pb-10">Before switching</h3>
              {beforeItems.map((item, index) => (
                <BubbleTalk key={"before" + index} {...item} />
              ))}
            </Col>
            <Col xs="0" md="2" className="overflow-hidden d-none d-md-block">
              <img src={imgArrow} alt="" className="mx-auto w-85" />
              <div className="mx-auto h-100 before-after-vl"></div>
            </Col>
            <Col xs="12" md="5" className="text-center">
              <h3 className="pb-10">
                <span className="highlighted2 pb-10">After switching</span>
              </h3>
              {afterItems.map((item, index) => (
                <BubbleTalk key={"after" + index} {...item} showStars={true} />
              ))}
            </Col>
          </Row>
          <Row>
            <Col xs="12" className="text-center pb-8 pb-lg-12">
              <div className="gr-text-10">
                {showLoadMore && (
                  <div>
                    <Button variant="light" onClick={loadMoreReviews}>
                      Read More...
                    </Button>
                  </div>
                )}
                <div className="py-3 px-6 rounded-20 d-inline-block text-muted">
                  We've got {totalReviews} more quotes like these
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default PeopleAreTalking;
